"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectionsRequests = void 0;
var http_1 = require("../services/http");
var toClientModel_1 = require("../services/utils/toClientModel/toClientModel");
var _helpers_1 = require("./_helpers");
var normalize = function (resp) {
    return resp.collections.map(toClientModel_1.toClientModel);
};
var normalizeOne = function (resp) {
    return toClientModel_1.toClientModel(resp.collection);
};
exports.collectionsRequests = {
    getAllOfEveryType: function (withItems) {
        return http_1.http({
            method: 'GET',
            url: "/collections/all",
            params: {
                include_items: withItems,
            },
        }).then(normalize);
    },
    getAll: function (type, withItems) {
        return http_1.http({
            method: 'GET',
            url: "/collections",
            params: {
                type: type,
                include_items: withItems,
            },
        }).then(normalize);
    },
    create: function (collection) {
        return http_1.http({
            method: 'POST',
            url: "/collections",
            data: collection,
        }).then(normalizeOne);
    },
    get: function (collectionOrId) {
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        return http_1.http({
            method: 'GET',
            url: "/" + _helpers_1.collectionsUrlPart(collectionOrId),
        }).then(normalizeOne);
    },
    partialUpdateProperties: function (collectionOrId, fieldsToUpdate) {
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        return http_1.http({
            method: 'PUT',
            url: "^/" + _helpers_1.collectionsUrlPart(collectionOrId),
            data: fieldsToUpdate,
        }).then(normalizeOne);
    },
    updateProperties: function (collection) {
        if (!_helpers_1.getId(collection)) {
            return _helpers_1.getNoIdPromise();
        }
        return http_1.http({
            method: 'PUT',
            url: "/" + _helpers_1.collectionsUrlPart(collection.id),
            data: collection,
        }).then(normalizeOne);
    },
    delete: function (collectionOrId) {
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        return http_1.http({
            method: 'DELETE',
            url: "/" + _helpers_1.collectionsUrlPart(collectionOrId),
        }).then(normalizeOne);
    },
    publish: function (collectionOrId) {
        if (!_helpers_1.getId(collectionOrId)) {
            return _helpers_1.getNoIdPromise();
        }
        return http_1.http({
            method: 'POST',
            url: "/" + _helpers_1.collectionsUrlPart(collectionOrId),
        }).then(normalizeOne);
    },
};
//# sourceMappingURL=collections.js.map